class Template {
	static single01(key1, content, size) {
		return [
			<div key={key1}>
				<div style={{ whiteSpace: "pre-line", fontSize: size }}>{content}</div>
			</div>,
		];
	}

	static simple00(key1, titleType, title, content, sizeTitle, sizeContent) {
		var output = [
			<div key={key1}>
				<div style={{ whiteSpace: "pre-line", fontSize: sizeTitle }}>
					{/* <h2>{title}</h2> */}
					{titleType == 1 ? <b>{title}</b> : <h2>{title}</h2>}
				</div>
				<div style={{ whiteSpace: "pre-line", fontSize: sizeContent }}>
					{content}
				</div>
			</div>,
		];
		return output;
	}
	
	static simple01(key1, title, content, sizeTitle, sizeContent) {
		return Template.simple00(key1, 0, title, content, sizeTitle, sizeContent);
	}

	static simple01x2(key1, title1, content1, size1, title2, content2, size2) {
		var part1 = Template.simple01("key1", title1, content1, size1, size1);
		var part2 = Template.simple01("key2", title2, content2, size2, size2);
		return [
			<div key={key1}>
				{part1}
				{part2}
			</div>,
		];
	}
	static simple_title_sub_content(
		key1,
		title,
		subtitle,
		content,
		sizeTitle,
		sizeContent
	) {
		var output = [
			<div key={key1}>
				<div style={{ whiteSpace: "pre-line", fontSize: sizeTitle }}>
					<b>{title}</b> {subtitle}
				</div>
				<div style={{ whiteSpace: "pre-line", fontSize: sizeContent }}>
					{content}
				</div>
			</div>,
		];
		return output;
	}
	static simple3size(
		key1,
		title,
		content1,
		content2,
		sizeTitle,
		sizeContent1,
		sizeContent2
	) {
		var output = [
			<div key={key1}>
				<div style={{ whiteSpace: "pre-line", fontSize: sizeTitle }}>
					<h2>{title}</h2>
				</div>
				<div style={{ whiteSpace: "pre-line", fontSize: sizeContent1 }}>
					{content1}
				</div>
				<div style={{ whiteSpace: "pre-line", fontSize: sizeContent2 }}>
					{content2}
				</div>
			</div>,
		];
		return output;
	}
	static simple4size(key1, txt1, txt2, txt3, txt4, size1, size2, size3, size4) {
		var output = [
			<div key={key1}>
				<div style={{ whiteSpace: "pre-line", fontSize: size1 }}>
					<b>{txt1}</b>
				</div>
				<div style={{ whiteSpace: "pre-line", fontSize: size2 }}>{txt2}</div>
				<div style={{ whiteSpace: "pre-line", fontSize: size3 }}>{txt3}</div>
				<div style={{ whiteSpace: "pre-line", fontSize: size4 }}>{txt4}</div>
			</div>,
		];
		return output;
	}
}
export default Template;
